import { apiCall } from "./apiCall";

export default function productApi() {
  return {
    getProductsList: (data, token) => apiCall("/getProductsList", data, token),
    getProducts: (data, token) => apiCall("/getProducts", data, token),
    getMasterProductList: (data, token) =>
      apiCall("/getMasterList", data, token),
    getMasterProductById: (data, token) =>
      apiCall("/getMasterProductById", data, token),
    getMasterData: (data, token) => apiCall("/getMasterProduct", data, token),
    createMaster: (data, token) => apiCall("/addMasterProduct", data, token),
    updateMasterProduct: (data, token) =>
      apiCall("/updateMasterProduct", data, token),
    getProductById: (data, token) => apiCall("/getProductById", data, token),
    getGenbaProducts: (data, token) =>
      apiCall("/getGenbaProductsList", data, token),
    getEzPinProducts: (data, token) => apiCall("/fetchProducts", data, token),
    deleteMasterProduct: (data, token) =>
      apiCall("/deleteMasterProduct", data, token),
    create: (data, token) => apiCall("/addProduct", data, token),
    deleteProductById: (data, token) => apiCall("/deleteProduct", data, token),
    updateProductById: (data, token) => apiCall("/updateProduct", data, token),
    getMasterProductsByMerchantId: (data, token) =>
      apiCall("/getMasterProductsByMerchantId", data, token),
    setTransaction: (data, token) => apiCall("/setTransaction", data, token),
    getTransactionHistory: (data, token) =>
      apiCall("/getTransactionHistory", data, token),
    getTransactionListById: (data, token) =>
      apiCall("/getTransactionListById", data, token),
    uploadProductKeys: (data, token) =>
      apiCall("/uploadProductKeys", data, token),
    getMasterStockHistory: (data, token) =>
      apiCall("/getMasterStockHistory", data, token),
    exportMasterStockHistory: (data, token) =>
      apiCall("/exportMasterStockHistory", data, token),
    downloadUploadQty: (data, token) =>
      apiCall("/downloadUploadQty", data, token),
  };
}
